module.exports = __webpack_public_path__ + "tile-2-overlay-3ifxIH4.webp";